export default {
    title: 'Löschen',
    deleteAction: 'Keinen Nutzer löschen | {count} Nutzer löschen | {count} Nutzer löschen',
    usersNotDeletable: 'Die Auswahl enthält Nutzer, die Sie nicht löschen können, da sie eine Rolle besitzen, die Sie nicht bearbeiten dürfen.',
    reallyDelete: 'Möchten Sie die ausgewählten Nutzer wirklich löschen?',
    reallyDeleteDeletableUsers: 'Möchten Sie die ausgewählten Nutzer wirklich löschen? Die nicht löschbaren Nutzer werden übersprungen.',
    deletedUsers: 'Die Nutzer wurden gelöscht.'
}